// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { epochToYYYYMMDD } from 'helpers/timeConversion'
import { castToString } from 'helpers/reduxFormFunctions'

const getAntennaPatternInfo = ({ antennaPattern, patterns, includeIds = false }) => {
  if (!antennaPattern) {
    return {
      antennaPatternId: null,
      patterns,
      rpeDate: '',
      rpeNumber: '',
    }
  }

  const antennaPatternId = (
    includeIds
      ? antennaPattern.antennaPatternId
      : null
  )

  const rpeDate = epochToYYYYMMDD(antennaPattern.rpeDate) || ''
  const rpeNumber = castToString(antennaPattern.rpeNumber)

  // antennaPatternPoints is an array of points combined from all patPols.
  // here we'll split it out so the patterns object holds these pattern points
  // separated in their own respective arrays.
  // eg.
  // antennaPatternPoints = [{VV}, {VH}, ...]
  // =>
  // patterns = {
  //   VV: [...],
  //   VH: [...],
  //   ...
  // }
  antennaPattern.antennaPatternPoints.map(pp => {
    // get this point's patPol string value to map it to the pattern's object
    const { patPol } = pp.patPol
    const angle = castToString(pp.discrimAngle)
    const discrimination = castToString(pp.discrimDb)

    // do not include the id for this point if
    // the caller doesn't explicitly request them.
    const antennaPatternPointId = (
      includeIds
        ? pp.antennaPatternPointId
        : null
    )

    patterns[patPol].push({
      angle,
      discrimination,
      antennaPatternPointId,
    })
  })

  return {
    antennaPatternId,
    patterns,
    rpeDate,
    rpeNumber,
  }
}

export default getAntennaPatternInfo
